export default __webpack_public_path__ + "static/media/skip-forward.f10f3a39.svg";